import HistoricalLeaderboard from './HistoricalLeaderboard';
export default HistoricalLeaderboard;
